import { BrowserModule } from "@angular/platform-browser";
import { APP_BASE_HREF } from "@angular/common";
import { NgModule, Component } from "@angular/core";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { SharedModule } from "./shared.module";
import { ScrollToModule } from "@nicky-lenaers/ngx-scroll-to";
import { AppPreloadingStrategy } from "./@core/CustomPreloadingStrategy";
import { NgxSmartModalModule } from "ngx-smart-modal";
import { NgxStripeModule } from 'ngx-stripe';
import { environment } from "src/environments/environment";
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    SharedModule,
    AppRoutingModule,
    NgxSmartModalModule.forRoot(),
    ScrollToModule.forRoot(),
    NgxStripeModule.forRoot(environment?.pKey || ''),

  ],
  providers: [{ provide: APP_BASE_HREF, useValue: "/" }, AppPreloadingStrategy],
  bootstrap: [AppComponent]
})
export class AppModule { }
